import { callApi } from './api';

import { Vehicle, CreateVehicleRequest } from '@/types/vehicle';

export const createVehicle = async (requestBody: CreateVehicleRequest) => {
  const { status, result } = await callApi<Vehicle>(
    'vehicles',
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
